import { motion } from "framer-motion";
import { UserPlus, Megaphone, HandHeart, ArrowUpRight, Sparkles, BookOpen, Camera, Users } from "lucide-react";
import { LINKS } from "@/data/site";

const cards = [
  {
    icon: UserPlus,
    title: "Become a Member",
    text: "Join our youth-led community and help shape the future of animal advocacy.",
    href: LINKS.member,
    bg: "bg-[#F2CC8F]",
    testid: "involved-member",
  },
  {
    icon: Megaphone,
    title: "Marketing Tails",
    text: "Volunteer to spread awareness through social media, design, and storytelling.",
    href: LINKS.marketing,
    bg: "bg-[#F4EBD9]",
    testid: "involved-marketing",
  },
  {
    icon: HandHeart,
    title: "Paws of Appreciation",
    text: "Volunteer to celebrate shelters and animals with heartfelt appreciation projects.",
    href: LINKS.paws,
    bg: "bg-[#FDE8DF]",
    testid: "involved-paws",
  },
  {
    icon: Sparkles,
    title: "Haven for Tails Ambassadors",
    text: "Become an ambassador to host a donation drive under Haven for Tails in your community.",
    href: "https://forms.gle/wuFgEp23GmTUJyvt6",
    bg: "bg-[#EFD8B4]",
    testid: "involved-ambassadors",
  },
  {
    icon: BookOpen,
    title: "Pet Care Education Team",
    text: "Volunteer to spread awareness of strategies to care for pets.",
    href: "https://forms.gle/sn8ke2wHTRno5dMn7",
    bg: "bg-[#FBE9CE]",
    testid: "involved-education",
  },
  {
    icon: Camera,
    title: "Pet Photography Team",
    text: "Share pictures and stories of your pets or shelter animals for volunteer hours.",
    href: "https://forms.gle/4fCFo6WiwfxgU1VQ6",
    bg: "bg-[#FADFC7]",
    testid: "involved-photography",
  },
  {
    icon: Users,
    title: "Haven for Tails Chapter Application",
    text: "Create a branch of Haven for Tails in your community or school today!",
    href: "https://forms.gle/vRbwSExfcFaqTnKRA",
    bg: "bg-[#F3D9B3]",
    testid: "involved-chapter",
  },
];

export const GetInvolved = () => {
  return (
    <section
      id="involved"
      className="relative z-10 bg-[#FDFBF7] py-24 lg:py-32"
      data-testid="involved-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-xs tracking-[0.3em] uppercase font-medium text-[#E07A5F] mb-6">
            Get Involved
          </p>
          <h2 className="font-display text-4xl sm:text-5xl font-bold text-[#2B2D42] leading-tight tracking-tight">
            Young people can be powerful change-makers.
          </h2>
          <p className="mt-6 text-lg text-[#4A4E69] leading-relaxed">
            There are easy, meaningful ways to help. Pick one that speaks to you —
            every bit of kindness counts.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {cards.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.a
                key={c.title}
                href={c.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={c.testid}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.12 }}
                className={`group relative flex flex-col rounded-3xl ${c.bg} p-8 transition-all hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgba(43,45,66,0.12)]`}
              >
                <div className="flex items-center justify-between">
                  <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-white/70 text-[#E07A5F]">
                    <Icon className="h-7 w-7" />
                  </span>
                  <ArrowUpRight className="h-6 w-6 text-[#2B2D42]/50 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
                <h3 className="mt-8 font-display text-2xl font-bold text-[#2B2D42]">
                  {c.title}
                </h3>
                <p className="mt-3 text-[#4A4E69] leading-relaxed">{c.text}</p>
                <span className="mt-6 text-sm font-semibold text-[#E07A5F]">
                  Open form →
                </span>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
